(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('SodState', SodState);

    function SodState(lodash) {
        var mem = {};
        return {
            sync: sync,
            destroy: destroy,
            set: set
        };

        function sync(vm) {
            lodash.set(mem, 'model', vm.model);
        }

        function destroy() {
            mem = {};
        }

        function set(field, value) {
            lodash.set(mem.model, field, value);
        }
    }
})();